import Login from './Login';
import OutletGeoCompliance from './OutletGeoCompliance';
import OperationalReports from './OperationalReports';
import OutletStatus from './OutletStatus';
import SalesmanDeviceId from './SalesmanDeviceId';
import MerchandizingSets from './MerchandizingSets';
import MerchandizerMaster from './MerchandizerMaster';

const COMMON ={
    ...Login,
    ...OperationalReports,
    ...OutletStatus,
    ...SalesmanDeviceId,
    ...OutletGeoCompliance,
    ...MerchandizingSets,
    ...MerchandizerMaster
}

export default COMMON;